import {observer} from "mobx-react";
import {Component} from "preact";
import {resources} from "../resources";
import {Button} from "./controls/Button";
import {LockerView} from "./LockerView";
import style from "./NoOccupancy.module.css";

export const NoOccupancy = observer(
	class NoOccupancy extends Component<{ onGetLocker: () => void }> {
		render() {
			const {onGetLocker} = this.props;
			return (
				<div class={style.noOccupancy}>
					<div class={style.noLockerMessage}>
						{resources.strings.NoLockers}
					</div>

					<div class={style.lockerContainer}>
						<LockerView number={"X"} inactive />
					</div>

					<Button primary onClick={onGetLocker}>
						{resources.strings.GetLocker}
					</Button>
				</div>
			);
		}
	},
);
